import React from 'react';
import { BaseComponentProps } from '@/pages/benchmark/types/commom';
import classNames from 'classnames';
import './index.scss';

interface IStudioAssessneRatingBarProps extends BaseComponentProps {
  colorList: string[];
  colorTextList?: string[];
  textList?: string[];
  preText?: string;
}

const StudioAssessneRatingBar = (props: IStudioAssessneRatingBarProps) => {
  const {
    style,
    className,
    colorList = [],
    colorTextList = [],
    textList = [],
    preText = '',
  } = props;

  return (
    <div
      className={classNames(
        'dbh-studio-assessnebt-rating-bar-container',
        className,
      )}
      style={style}
    >
      <div className="dbh-studio-assessnebt-rating-bar-process">
        <div className="dbh-studio-assessnebt-rating-bar-process-list">
          {colorList?.map((color, index) => (
            <div
              key={color}
              className="dbh-studio-assessnebt-rating-bar-process-item"
              style={{ backgroundColor: color }}
            >
              {colorTextList[index] ?? ''}
            </div>
          ))}
        </div>
      </div>
      <div className="dbh-studio-assessnebt-rating-bar-text">
        {preText && (
          <div className="dbh-studio-assessnebt-rating-bar-pre-text">
            {preText}
          </div>
        )}
        {textList?.map((text, index) => (
          <div
            key={text}
            className={classNames(
              'dbh-studio-assessnebt-rating-bar-text-item',
              {
                'dbh-studio-assessnebt-rating-bar-text-item-first': index === 0,
                'dbh-studio-assessnebt-rating-bar-text-item-last':
                  index === textList?.length - 1,
              },
            )}
          >
            {text}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StudioAssessneRatingBar;
